import React from 'react';
import PropTypes, { shape } from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import { get } from 'dpl/shared/utils/object';

const AUTHOR_IMAGE_DIAMETER = '64px';

export default function Reviewer({ sliceData }) {
  const reviewerData = get(sliceData, 'primary.reviewer.data');
  if (!reviewerData) return null;

  return (
    <div className="PrismicReviewer">
      <div className="flex mb3">
        {reviewerData.avatar && reviewerData.avatar.url && (
          <SmartImage
            className="bg-center cover br-100"
            Tag="div"
            src={reviewerData.avatar.url}
            lazy
            width={AUTHOR_IMAGE_DIAMETER}
            height={AUTHOR_IMAGE_DIAMETER}
          />
        )}
        <div className="ml2">
          <div className="flex flex-wrap d-lg-block d-xl-flex">
            <p className="b">Reviewed by&nbsp;</p>
            <p className="purple b">{reviewerData.full_name}</p>
          </div>
          <p>{reviewerData.job_title}</p>
        </div>
      </div>
      <p className="f2">
        {reviewerData.full_name}&nbsp;{reviewerData.bio}
      </p>
    </div>
  );
}

Reviewer.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      reviewer: PropTypes.shape({
        data: PropTypes.shape({
          full_name: PropTypes.string.isRequired,
          job_title: PropTypes.string,
          bio: PropTypes.string,
          avatar: shape({
            url: PropTypes.string
          })
        })
      }).isRequired
    }).isRequired
  }).isRequired
};
